// Anonymous per-device identity for Call God (Phase 3).
// No accounts, no PII — a random id in localStorage that scopes saved
// reflections and feedback to this browser. Clearing site data removes it.

const KEY = "callgod_device_v1";

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      const rand =
        (typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36));
      id = "d_" + rand.replace(/-/g, "").slice(0, 24);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return "d_anonymous"; // storage unavailable (private mode) — shared fallback id
  }
}
